module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7yLW3"))).then(() => parcelRequire('hEqeo'));